<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.infoDiv {
  width: 50%;
  height: 40px;
  border: 1px solid #bb87f370;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
}
.moneyDiv {
  width: 100%;
  height: 40px;
  background-color: #bb87f313;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
  margin: 20px 0;
}
.el-checkbox__inner {
  width: 18px;
  height: 18px;
}
// /deep/.el-input__inner {
//     background: #F8F9FC;
//     font-size: 12px;
//     font-weight: 400;
//     color: #BCBCBC;
//     line-height: 17px;
//     font-family: PingFangSC-Regular, PingFang SC;
//     border-radius: 4px;
// }
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.SiteDiscountRateListBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">客户&站点折扣费率管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">用户手机号</div>
            <el-input
            size="small"
            :disabled="disabled"
              v-model="queryInfo.mobile"
              placeholder="申请人手机号码"
            ></el-input>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">所属电站</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.stationNo"
                filterable
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              >
                <el-option v-for="(item, index) in siteArr" :key="index" :label="item.stationName" :value="item.stationNo"></el-option>
              </el-select>
            </div>
          </div>
        </template>
        <template slot="actions">
            <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜索
          </button>
          <button class="common-bg-button" @click="handleAdd">
            新增
          </button>
          <button class="common-bg-button" @click="handleExportFun()">
            导 出
          </button>
          <!-- <button class="common-empty-button" @click="reset()">重 置</button> -->
        </template>
      </ZD-list-querys>
     

      <div class="page-action-btns flex"></div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" :stripe="true" class="list_tb" border>
          <el-table-column type="index" align="center" width="55">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号码"
            min-width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="stationName"
            label="所属电站"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="stationDiscountVal"
            label="电费减免比例"
            min-width="170"
            align="center"
          >
          <template slot-scope="scope">
            <span>{{ scope.row.stationDiscountVal/0.01  }}%</span> 
          </template>
          </el-table-column>
          <el-table-column
            prop="stationDiscountServiceChargeVal"
            label="服务费减免比例"
            min-width="170"
            align="center"
          >
          <template slot-scope="scope">
            <span>{{ scope.row.stationDiscountServiceChargeVal/0.01  }}%</span> 
          </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="effectStartTime"
            label="有效期开始时间"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="effectEndTime"
            label="有效期结束时间"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="effectElec"
            label="折扣度数"
            min-width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="affiliationType"
            label="操作"
            min-width="170"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
          
          <!--分页区 -->
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
    <!-- 表格 -->
  </div>
</template>

<script>
import axios from "axios";
import pageConfig from "../page-config";
import moment from 'moment'
export default {
  data() {
    return {
      invoicingStatus:'',
     
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      dea1erList: [],
      stationList: [],
      pagination: pageConfig.pagination,
      queryInfo: {
        mobile:'',
        stationNo:''
      },
      source: [],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      }, // 列操作按钮
      searchTime: [], //选择时间
      siteArr:[],
      infoList: {},
      pickerOptions: {
        //修改el-date-picker的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      disabled:false,
    };
  },
  methods: {
    
    init() {
      // this.queryInfo.id =  ''
      // this.queryInfo.custNo = ''
      this.queryInfo.mobile = ''
      this.getListData(this.pagination, true);
      this.getsite();
    },
    //秒数转化为时分秒
    formatSeconds(value) {
      var secondTime = parseInt(value); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      var result = "" + parseInt(secondTime) + "秒";

      if (minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
      }
      console.log("result", result);
      return result;
    },
    getsite(){
      let _ = this
      _.$H.post(_, _.$A.pileStation.listStationByDeal, {}).then((res) => {
        _.siteArr = res.data.data.map(item=>{
          return {
            stationNo:item.stationNo,
            stationName:item.stationName,
          }
        })
      });
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      // if (_.queryInfo.chargeMonth == null || _.queryInfo.chargeMonth == "") {
      //   return _.$message.error("请选择月份!");
      // }
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      // _.queryInfo.id = _.$route.query.id?_.$store.state.editId:'';
      if(_.$route.query.mobile){
        _.disabled = true
      }
      _.queryInfo.mobile = _.$route.query.mobile?_.$store.state.mobile:'';
      // _.queryInfo.custNo = _.$route.query.custNo?_.$store.state.custNo:'';
      // delete _.queryInfo.pageConfig;
      _.$H
        .get(_, _.$A.cust.page, _.queryInfo)
        .then((res) => {
          _.tableData = res.data.data.content || [];
            _.pagination.total = res.data.data.totalElements || 0;
          
          _.$U.hideLoading(_);
        });
    },
    handleAdd(){
      window.open(
                this.$router.resolve({
                  name: pageConfig.setSiteDiscountRate,
                  query:{
                    custNo:this.$route.query.custNo
                  }
                }).href,
                "_blank"
              );
    },
    handleEdit(val){
      window.open(
                this.$router.resolve({
                  name: pageConfig.setSiteDiscountRate,
                  query:{id:val.id,custNo:val.custNo}
                }).href,
                "_blank"
              );
    },
    handleDelete(val){
      this.$confirm('此操作将删除该条信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let url = this.$A.cust.delDiscount + `${val.id}`;
                    this.$H.del(this, url, {}).then(res => {
                        this.$U.success('删除成功');
                        setTimeout(() => {
                          this.getListData(this.pagination, true);
                        }, 1000)
                    })
       
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    handleExportFun() {
      let _ = this;
        _.$U.showLoading(_);
        
        _.$H
          .post(_, _.$A.cust.export, _.queryInfo)
          .then((res) => {
            _.$U.hideLoading(_);
            let filePath = res.data.data.data;
            // let downUrl = "http://192.168.8.203:9000" + filePath; // 后台本地地址
            // let downUrl = "http://192.168.8.174:7999" + filePath; // 测试地址
            let downUrl = "http://ocharge.shzhida.com:6777" + filePath; // 正式地址
            // window.open(downUrl, "_blank");
          });
    },
  },
  mounted() {
    this.init();
    // this.getDealer();
  },
};
</script>
